var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMsWindows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 27 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m11.87 25.163-11.071-1.6v-9.348h11.07v10.948Zm0-11.809H.798V4.498l11.07-1.6v10.456Zm15.129 13.9L12.73 25.163V14.215H27v13.039Zm0-13.9H12.73V2.9L27 .808v12.546Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsWindows);
export default __webpack_public_path__ + "static/media/ms-windows.cbd8dc02b0de34cac6190114e2a4519d.svg";
export { ForwardRef as ReactComponent };